<template>
    <div class="label-wrap">
        <ul class="label" v-if="labels.length">
            <li
                class="item"
                :class="{active: index === activeIndex}"
                v-for="(item, index) in labels"
                :key="index"
                @click="setOptions(item, index)">
                {{item.typeName}}
            </li>
        </ul>
        
    </div>
</template>
<script>

export default {
    name: 'labels',
    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        i: {
            type: Number,
            default: -1,
        }
    },
    data() {
        return {
            activeIndex: -1,
        }
    },
    watch: {
        i(val) {
            this.activeIndex = val
        }
    },
    methods: {
        setOptions(item, index) {
            this.$emit('setOptions', item)
            this.activeIndex = index
        },
    },
}
</script>
<style scoped lang="scss">
    .label{
        margin-left: -.32rem;
        margin-top: -0.21rem;
        padding: .43rem .66rem;
        background: #fff;
        border-bottom: 1PX solid #F2F4F6;
    }
    .item{
        display: inline-block;
        margin-top: 0.21rem;
        margin-left: .32rem;
        width: 1.92rem;
        height: 0.82rem;
        line-height: 0.82rem;
        background: #F6F6F6;
        border-radius: 0.16rem;
        color: #9298A8;
        font-size: 0.38rem;
        text-align: center;
        &.active{
            background: #06B455;
            color: #fff;
        }
    }
    
</style>
